import { getTranslatedText } from "../../../../utils/getTranslatedText";
import { useGetTranslatedText } from "../../lms/queries";
import styles from "./styles.module.scss";
// import Successmark from '../../../../../public/Images/Successmark.svg'

const SuccessModal = ({setDocumentUploadedSuccessfully}) => {
  
  const  handleClick = () => {
    setDocumentUploadedSuccessfully(false);
  }

  const languageId = localStorage.getItem("l_id") || 1;
    
  const { data: translatedTextResponse } = useGetTranslatedText(languageId);
    
  const { data: translatedText = [] } = translatedTextResponse || {};

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        
        {/* Icon */}
        <div className={styles.iconWrapper}>
          {/* <div className={styles.checkIcon}>✔</div> */}
          <img  src="../../Images/Successmark.svg" alt="success-icon" />
        </div>

        {/* Title */}
        <h2 className={styles.title}>
          {
            getTranslatedText(
              translatedText,
              "Submitted Successfully",
              "Submitted Successfully",
            )
            }
          </h2>

        {/* Description */}
        <p className={styles.description}>
          {
            getTranslatedText(
              translatedText,
              "tv_success_desc",
              `Your documentation has been submitted and is now under admin review.
          You will be notified once the review is complete.`,
            )
          }
        </p>

        {/* Button */}
        <button className={styles.button} onClick={handleClick}>
          {
            getTranslatedText(
              translatedText,
              "got_it",
              `Got it!`,
            )
          }
          
        </button>

      </div>
    </div>
  );
};

export default SuccessModal;